<template>
  <div style="overflow-x: auto">
    <table-loader :fields="fields" v-if="loading"/>
    <b-card no-body v-else>
      <b-table
        hover striped show-empty responsive
        :items="workshopParticipants"
        :fields="fields"
        no-border-collapse
        outlined
        head-variant="light"
      >
			  <template slot="cell(person.last_name)" slot-scope="row">
					{{ row.item.person.last_name }}
					<span v-if="row.item.person.workshop_accepted_type == 'Declined'" class="px-2 badge badge-pill badge-danger">Declined</span>
        </template>
        <template slot="cell(person.home_institution)" slot-scope="row">
          <span>
            {{ row.item.person.home_institution ? row.item.person.home_institution.name : '-' }}
          </span>
        </template>
        <template v-if="canEditCms" #cell(created_at)="row">
          <span class="text-nowrap">
            {{ moment(row.item.created_at, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY hh:mm a") }}
          </span>
        </template>
        <template v-if="canEditCms" #cell(actions)="row">
          <i
            v-b-tooltip.hover="'Show Details'"
            v-b-modal="'workshopParticipants'"
            class="fas fa-eye cursor-pointer typo-color-blue"
            @click="openModal(row.item)"
          />
        </template>
      </b-table>
    </b-card>
    <b-modal
      id="workshopParticipants"
      ref="workshopParticipants"
      title="Registration Info"
      size="lg"
      centered
      hide-footer
    >
      <workshop-participants-tab-show-section :selected-participant="selectedParticipant" />
    </b-modal>
  </div>
</template>

<script>
import WorkshopParticipantsTabShowSection from "./WorkshopParticipantsTabShowSection.vue"
import { mapGetters } from "vuex"
import TableLoader from "@/components/Loaders/TableLoader.vue"

export default {
	name: "WorkshopParticipantsTabSection",
	components: { WorkshopParticipantsTabShowSection, TableLoader },
	computed: {
		...mapGetters(["canEditCms", "authUser"]),
		fields() {
			return [
				{
					key: "person.first_name",
					label: "First Name",
					sortable: true,
				},
				{
					key: "person.last_name",
					label: "Last Name",
					sortable: true,
				},
				{
					key: "person.home_institution.name",
					label: "Home Institution",
					sortable: true,
				},
				...(this.canEditCms
					? [
							{
								key: "created_at",
								label: "Registered On",
								sortable: true,
							},
							"actions",
						]
					: []),
			]
		},
	},
	data() {
		return {
			selectedParticipant: {},
			workshopParticipants: [],
			loading: true,
		}
	},
	mounted() {
		this.$root.$on("workshopParticipants", () => {
			this.$refs.workshopParticipants.hide()
		})
		this.loadWorkshopParticipants()
	},
	methods: {
		openModal(participant) {
			this.selectedParticipant = participant
			this.$bvModal.show("workshopParticipants")
		},
		loadWorkshopParticipants() {
			this.loading = true
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/workshops/${this.$route.params.id}/workshop_participants`)
				.then((res) => {
					this.workshopParticipants = res.data.participants
					this.loading = false
				})
		},
	},
}
</script>
